import axios from '../utils/axios';

export const login = (body) => {
    return axios.post('/prod/authentication', body).then((response) => {
        return response.data;
    });
};
